import { Checkbox, TableCell, TableRow } from "@mui/material";
import React from "react";
import PlayCircleFilledWhiteOutlinedIcon from "@mui/icons-material/PlayCircleFilledWhiteOutlined";
// import img from "./img.jpg";
import moment from "moment";
import { formatLength, images } from "../../../../../constants";

const GAReactionsTableRow = ({
  isItemSelected,
  row,
  numberType,
  handleClickRow,
  labelId,
  handleImagePreviewModalOpen,
  handleAudioModalOpen,
  handleNavigateToDetails,
  setSelectedAudioFile,
  setSelectedImage,
  columnWidths,
}) => {
  return (
    <TableRow
      hover
      // onClick={(event) => handleClickRow(event, row.id)}
      role="checkbox"
      aria-checked={isItemSelected}
      tabIndex={-1}
      key={row.id}
      selected={isItemSelected}
      sx={{
        cursor: "pointer",
        height: 48,
        background: numberType === true ? "#F2F2F2" : "#fff",
      }}
    >
      <TableCell
        padding="checkbox"
        style={{ background: "#fff" }}
        onClick={(event) => handleClickRow(event, row.id)}
      >
        <Checkbox
          color="primary"
          checked={isItemSelected}
          inputProps={{
            "aria-labelledby": labelId,
          }}
        />
      </TableCell>
      <TableCell
        id={labelId}
        scope="row"
        padding="none"
        onClick={handleNavigateToDetails}
        style={{
          ...tableTitleFieldStyles,
          width: columnWidths?.["quicktaleData.title"] || 200,
          minWidth: columnWidths?.["quicktaleData.title"] || 150,
          maxWidth: columnWidths?.["quicktaleData.title"] || 300,
        }}
        title={row?.quicktaleData?.title}
      >
        {row?.quicktaleData?.title}
      </TableCell>
      <TableCell
        align="center"
        padding="none"
        onClick={() => {
          setSelectedAudioFile(row?.processedAudioUrl || row?.audioUrl);
          handleAudioModalOpen();
        }}
        style={{
          border: "1px solid #BABABA",
          width: columnWidths?.audio || 150,
          minWidth: columnWidths?.audio || 100,
          maxWidth: columnWidths?.audio || 200,
        }}
      >
        <PlayCircleFilledWhiteOutlinedIcon
          fontSize="large"
          style={{ color: "#00A7CD" }}
        />
      </TableCell>
      <TableCell 
        padding="none" 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.id || 140,
          minWidth: columnWidths?.id || 100,
          maxWidth: columnWidths?.id || 200,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          position: 'relative',
        }}
        title={row.id}
      >
        <div style={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          width: '100%',
          maxWidth: columnWidths?.id || 140,
        }}>
          {row.id}
        </div>
      </TableCell>
      <TableCell
        align="left"
        padding="none"
        style={{
          ...tableCellStyles,
          textTransform: "capitalize",
          width: columnWidths?.status || 170,
          minWidth: columnWidths?.status || 120,
          maxWidth: columnWidths?.status || 220,
        }}
      >
        <div
          style={{
            color:
              row.status == "pending"
                ? "#E48900"
                : row.status == "approved"
                ? "#128D1F"
                : row.status == "denied"
                ? "#BA344C"
                : "#020303",
          }}
        >
          {row.status}
        </div>
      </TableCell>
      <TableCell 
        padding="none" 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.["userData.userName"] || 170,
          minWidth: columnWidths?.["userData.userName"] || 120,
          maxWidth: columnWidths?.["userData.userName"] || 220,
        }}
      >
        {row?.userData?.userName || (row?.displayName ? `Guest - ${row.displayName}` : "Guest")}
      </TableCell>
      <TableCell 
        padding="none" 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.createdAt || 170,
          minWidth: columnWidths?.createdAt || 120,
          maxWidth: columnWidths?.createdAt || 220,
        }}
      >
        {row?.createdAt &&
          moment.unix(row?.createdAt?.seconds).format("MM-DD-YYYY HH:mm:ss")}
      </TableCell>
      <TableCell 
        padding="none" 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.audioLength || 140,
          minWidth: columnWidths?.audioLength || 100,
          maxWidth: columnWidths?.audioLength || 180,
        }}
      >
        {row?.audioLength && formatLength(row?.audioLength)}
      </TableCell>
      <TableCell
        align="center"
        padding="none"
        style={{
          border: "1px solid #BABABA",
          width: columnWidths?.image || 150,
          minWidth: columnWidths?.image || 100,
          maxWidth: columnWidths?.image || 200,
        }}
        onClick={() => {
          setSelectedImage(
            row?.quicktaleData?.imageUrls && row?.quicktaleData?.imageUrls[0]
              ? row?.quicktaleData?.imageUrls[0]
              : images.QuicktaleLogo
            // row?.quicktaleData?.photoUrl
            //   ? row?.quicktaleData?.photoUrl
            //   : images.QuicktaleLogo
          );
          handleImagePreviewModalOpen();
        }}
      >
        <img
          src={
            row?.quicktaleData?.imageUrls && row?.quicktaleData?.imageUrls[0]
              ? row?.quicktaleData?.imageUrls[0]
              : images.QuicktaleLogo
          }
          // src={
          //   row?.quicktaleData?.photoUrl
          //     ? row?.quicktaleData?.photoUrl
          //     : images.QuicktaleLogo
          // }
          alt="table image"
          style={{ width: 45, height: 40 }}
        />
      </TableCell>

      <TableCell 
        padding="none" 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.quicktale || 170,
          minWidth: columnWidths?.quicktale || 120,
          maxWidth: columnWidths?.quicktale || 220,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          position: 'relative',
        }}
        title={row.quicktale}
      >
        <div style={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          width: '100%',
          maxWidth: columnWidths?.quicktale || 170,
        }}>
          {row.quicktale}
        </div>
      </TableCell>
      <TableCell
        align="left"
        padding="none"
        style={{
          ...tableCellStyles,
          textTransform: "capitalize",
          width: columnWidths?.reportedStatus || 170,
          minWidth: columnWidths?.reportedStatus || 120,
          maxWidth: columnWidths?.reportedStatus || 220,
        }}
      >
        {row.reportedStatus}
      </TableCell>
    </TableRow>
  );
};

export default GAReactionsTableRow;

const tableTitleFieldStyles = {
  border: "1px solid #BABABA",
  paddingLeft: 10,
  color: "#00A7CD",
  // fontWeight: 600,
  fontFamily: "Avenir Book, sans-serif",
};

const tableCellStyles = {
  paddingLeft: 10,
  border: "1px solid #BABABA",
  cursor: "default",
  fontFamily: "Avenir Book, sans-serif",
};
// const tableStatusCellStyles = {
//   border: "1px solid #BABABA",
//   cursor: "pointer",
//   fontWeight: 600,
// };
